/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostscolumntokens3Inputs */

const en_aicostscolumntokens3 = /** @type {(inputs: Aicostscolumntokens3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens in / out`)
};

const de_aicostscolumntokens3 = /** @type {(inputs: Aicostscolumntokens3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens ein / aus`)
};

/**
* | output |
* | --- |
* | "Tokens in / out" |
*
* @param {Aicostscolumntokens3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscolumntokens3 = /** @type {((inputs?: Aicostscolumntokens3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscolumntokens3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscolumntokens3(inputs)
	return de_aicostscolumntokens3(inputs)
});
export { aicostscolumntokens3 as "aiCostsColumnTokens" }